/**
 * Shared range-id → human word helper.
 *
 * Used by every v2 page so sub-labels ("today", "this week", "lifetime")
 * stay in sync with the date pill the user picked. Without this, pages
 * silently say "lifetime" while showing windowed data.
 *
 *   rangeWordFor("today")      → "today"
 *   rangeWordFor("this-month") → "this month"
 *   rangeWordFor("till-date")  → "lifetime"
 *
 * Capitalised variant for sentence-leading use:
 *   capWord("today")           → "Today"
 *   capWord("this-week")       → "This week"
 */
const WORDS = {
  "today":      "today",
  "this-week":  "this week",
  "this-month": "this month",
  "last-month": "last month",
  "this-year":  "this year",
  "last-year":  "last year",
  "till-date":  "lifetime",
  "custom":     "selected range",
};

export function rangeWordFor(rangeId) {
  return WORDS[rangeId] || "this month";
}

export function capRangeWord(rangeId) {
  const w = rangeWordFor(rangeId);
  return w.charAt(0).toUpperCase() + w.slice(1);
}

export function granLabel(g) {
  return ({ hour: 'HOURLY', day: 'DAILY', week: 'WEEKLY', month: 'MONTHLY', year: 'YEARLY' })[g] || '';
}

export function granWord(g) {
  return ({ hour: 'hourly', day: 'daily', week: 'weekly', month: 'monthly', year: 'yearly' })[g] || '';
}
